import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useShallow } from 'zustand/react/shallow';

import { getRelativeRoute } from '@/router/routes';
import { useGradeFlow } from '@/states/grade-flow';

import { Button } from '@/components/ui/button';

type GRADING_CASE_STEPS = 'GRADING_CASE_STEP_1' | 'GRADING_CASE_STEP_2' | 'GRADING_CASE_STEP_3';
type INSIGHTS_DR_FORM_STEPS = 'INSIGHTS_DR_FORM_STEP_1' | 'INSIGHTS_DR_FORM_STEP_2';

type GoBackStepProps = {
  backTo: GRADING_CASE_STEPS | INSIGHTS_DR_FORM_STEPS;
  label?: string;
};

export function GoBackStep(props: GoBackStepProps) {
  const { backTo, label = 'Go Back' } = props;

  const { isSaving } = useGradeFlow(useShallow((s) => ({ isSaving: s.isSavingGrade })));
  const navigate = useNavigate();

  const handleGoBack = useCallback(() => {
    navigate(`../${getRelativeRoute(backTo)}`);
  }, [backTo, navigate]);

  return (
    <Button variant="ghost-muted" onClick={handleGoBack} disabled={isSaving}>
      {label}
    </Button>
  );
}
